import React, { createElement } from 'react';
import { DrawerForm } from '@ant-design/pro-components';
import { BaseDialog } from '../../shared/base/BaseDialog';
export default class ProDrawerForm extends BaseDialog {
    formRef = React.createRef();
    handleOpenChange = (open) => {
        if (!open) {
            this.hide();
        }
        if (this.props.onOpenChange) {
            this.props.onOpenChange(open);
        }
    };
    render() {
        const innerProps = this.transformProps();
        return (createElement(DrawerForm, { formRef: this.formRef, dateFormatter: 'number', ...this.props, ...innerProps, drawerProps: {
                destroyOnClose: true,
            }, onOpenChange: this.handleOpenChange }));
    }
}
